export default "__VITE_ASSET__BNN0jVPN__"